import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {KeycloakLv1871Service, KeycloakParameter, CoreSettings, SETTINGS, UiConfigService, RuntimeContext} from '@lv1871/core';
import {
  ButtonCommandService,
  EventService,
  ShellConfigService,
  ShellParameter,
  UiControl,
  UiModelService,
  ValidationService,
  RisikofragenService, UiControlData, flatMapWithParent, UIAusrichtung, UIWorkflowValidierung, UILayout, UIArtefaktGruppe,
} from '@lv1871/dialog-toolbox';
import {HttpClient} from '@angular/common/http';
import {IAppConfig,} from '../../../../lib-core/models/appConfig/iapp-config';
import {AntragsannahmeUrlParams} from '../../../../lib-dialog-toolbox/models/urlParams';
import {fromEvent, map, Observable, of, Subscription, take, tap} from 'rxjs';
import {AntragsannahmeComponent} from '@lv1871/antragsannahme';
import {MatIconRegistry} from '@angular/material/icon';
import {AppInitializer} from '../../services/setup/app.initializer';
import {MATOMO_ID, UserCentricsEventDetail} from '../../../../lib-dialog-toolbox/models/userCentricsEventDetail';
import {EncryptionService} from '../../../../lib-core/services/encryption.service';

@Component({
    selector: 'lv-antrag-wrapper',
    templateUrl: './antrag-wrapper.component.html',
    styleUrls: ['./antrag-wrapper.component.scss'],
    standalone: false
})
export class AntragWrapperComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @ViewChild('antragsannahme')
  public antragsannahme: AntragsannahmeComponent;

  @Input()
  public uiArtefakt: UIArtefaktGruppe;
  @Input()
  showMenu: boolean;
  @Input()
  showWorkflowButtons: boolean;
  @Input()
  showEntwicklerleiste: boolean;
  @Input()
  runtimeContext: RuntimeContext;
  @Input()
  uiLayout: UILayout;
  @Input()
  produktId: string;
  @Input()
  uiWorkflowValidierung: UIWorkflowValidierung;
  @Input()
  uiWorkflowStopBeiVotum: boolean;
  @Input()
  uiAusrichtung: UIAusrichtung;
  @Input()
  uiVorgangId: string;
  @Input()
  internalRequest: boolean;
  @Input()
  variantenvergleich: boolean;

  //Parsed Inputs
  // urlparams kann weg?
  @Input()
  urlParams: string;
  @Input()
  kollektivId: string;
  @Input()
  sessionId: string;
  @Input()
  antragsgenerationDatum: string;
  @Input()
  versicherungsnummer: string;
  @Input()
  schwebelfdnr: number;
  @Input()
  keycloakConfig: string;


  // TODO Wird aktuell nicht benötigt. Eventuell von GP-Portal als zukunfts feature geplant. Falls umsetzung benötigt. Muss per nativeElement exposed werden
  // public menuState$: Observable<MenuState> = this._eventService.menuState$.asObservable();
  // public menuItemSelected$: Observable<string> = this._eventService.menuItemSelected$.asObservable();
  // public requestMenuItemSelected$: Subject<string> = this._eventService.menuItemRequested$;

  //public componentType: string = 'Antrag'; //TODO Sinn war zweifelhaft: Einzige Nutzung war hard-coded string vergleich im SB-portal onActivate

  public settings$: Observable<IAppConfig>;
  public initial_onChanges: boolean = true;

  private _subscription = Subscription.EMPTY;

  constructor(public _uiConfigService: UiConfigService, private _shellConfigService: ShellConfigService,
              private http: HttpClient, private _keycloakLv1871Service: KeycloakLv1871Service, private _element: ElementRef,
              private _risikofragenService: RisikofragenService, private _validationService: ValidationService,
              private _buttonCommandService: ButtonCommandService, private _matIconRegistry: MatIconRegistry,
              private _appInitializer: AppInitializer, @Inject(SETTINGS) private _settings: CoreSettings,
              private _uiModelService: UiModelService, private _eventService: EventService,
              private _renderer: Renderer2, private _encryptionService: EncryptionService) {
    this._matIconRegistry.setDefaultFontSetClass('fa');
    this._appInitializer.init();
    this._element.nativeElement.clearVorgang = (uiControl: UiControl) => this.clearVorgang(uiControl);
    this._element.nativeElement.updateUiControlData = (uiControlData: UiControlData) => this.updateUiControlData(uiControlData);
    this._element.nativeElement.setRisikofragenFalse = () => this.setRisikofragenFalse();
    this._element.nativeElement.setRoetelnEnabled = (enabled: boolean) => this.setRoetelnEnabled(enabled);
    this._element.nativeElement.validateAllForms = () => this.validateAllForms();
    this._element.nativeElement.sendUiRequest = (uiControl: UiControl) => this.sendUiRequest(uiControl);
    this._element.nativeElement.postCommand = (command: string) => this.postCommand(command);

    this._element.nativeElement.uiControls$ = this._eventService.uiControlsUnmodified$;
    this._element.nativeElement.variantenvergleichData$ = this._eventService.variantenvergleichData$;
    this._element.nativeElement.antragBearbeiten$ = this._eventService.antragBearbeiten$;
    this._element.nativeElement.vermittlerdaten$ = this._eventService.vermittlerdaten$;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', 'lv-app-antrag');
  }

  ngOnInit(): void {

    window.addEventListener('message', (event) => {
      if (event.data?.id === 'BMAK_CUSTOM_TRACKING') {
        this._eventService.sessionId$.next(event.data.uuid);
      }
    });

    if (!!(window as never)[`app-antragsannahme-config`]) {
      this._uiConfigService.settings = (window as any)[`app-antragsannahme-config`] as IAppConfig;
      this._settings.app_root_url = this._uiConfigService.settings.public_path;
      this.settings$ = of(this._uiConfigService.settings);
    } else {
      this.settings$ = this.http.get<IAppConfig>('assets/config/config.develop.json').pipe(
          tap(config => {
            config.public_path = window.location.origin + '/';
            this._uiConfigService.settings = config;
            this._settings.app_root_url = this._uiConfigService.settings.public_path;
          }),
          take(1),
      );
    }
    this._eventService.consent$ = fromEvent(window, 'userCentricsEvent').pipe(
        map(event => event as CustomEvent<UserCentricsEventDetail>),
        map(event => ({
          matomo: event.detail[MATOMO_ID] || false
        }))
    );

  }

  clearVorgang(uiControl: UiControl) {
    let uiArtefakte = [];
    flatMapWithParent(uiControl.uiVorgang.UIArtefakt).forEach(({artefakt, parent}) => {
      if ((artefakt.FeldnameExtern === '/korrekturgrundZuVersicherungsbeginn'
          || artefakt.FeldnameExtern === '/versandInformationFalschpolicierung')) {
        uiArtefakte = [parent];
      }
    });
    const control = {
      uiVorgang: {
        UIArtefakt: uiArtefakte
      },
      versicherungsnummer: uiControl.versicherungsnummer
    } as UiControl;
    this._eventService.uiControls$.next(control);
    this._eventService.uiControlsNewst$.next(control);
    this.antragsannahme.reinit();
  }

  sendUiRequest(uiControl: UiControl) {
    return this._uiModelService.requestUiControl(uiControl);
  }

  updateUiControlData(uiControlData: UiControlData) {
    this._eventService.uiControls$.pipe(
        take(1),
        tap(uiControl => {
          const newUiControl = Object.assign(uiControl, uiControlData);
          this._eventService.uiControls$.next(newUiControl);
          this._eventService.uiControlsNewst$.next(newUiControl);
        })
    ).subscribe();
  }

  postCommand(command: string): Observable<any> {
    return this._buttonCommandService.postCommand(command);
  }

  validateAllForms() {
    this._validationService.validateAllForms();
  }

  setRoetelnEnabled(enabled: boolean) {
    this._eventService.roetelnEnabled$.next(enabled);
    this._uiModelService.reloadUiControl();
  }

  setRisikofragenFalse() {
    this._risikofragenService.setEmptyQuestionsFalse();
  }

  public isRuntimeContextCms(): boolean {
    return !!this._uiConfigService.settings?.environment && this._shellConfigService.getParameter().runtimeContext === RuntimeContext.CMS;
  }

  public getInstanaUrl(): string {
    return this._uiConfigService.getAntragserfassungUrl() + '/instana';
  }

  ngOnChanges(changes: SimpleChanges): void {
    const shellParams = {};
    for (const key in changes) {
      if (key === 'keycloakConfig') {
        shellParams[key] = JSON.parse(changes[key].currentValue);
      } else {
        shellParams[key] = changes[key].currentValue;
      }
    }

    if (!!shellParams['sessionId']) {
      this._eventService.sessionId$.next(shellParams['sessionId']);
    }

    this._shellConfigService.shellParameter = {
      ...this._shellConfigService.shellParameter,
      ...shellParams as ShellParameter
    };
    if (!this._keycloakLv1871Service.getParameter() ||
        !this._keycloakLv1871Service.getParameter().keycloakConfig) {
      this._keycloakLv1871Service.setParameter(shellParams as KeycloakParameter);
      this.initial_onChanges = false;
    } else {
      this.initial_onChanges = false;
    }

    const params: AntragsannahmeUrlParams = new AntragsannahmeUrlParams();
    const refInUrl = new URL(location.href).searchParams.get('ref');
    if (!!refInUrl) {
      const decryptedObject = JSON.parse(this._encryptionService.decrypt(refInUrl));
      if (!!decryptedObject['pid']) {
        params.produktId = decryptedObject['pid'];
      }
      if (!!decryptedObject['kid']) {
        params.kollektivId = decryptedObject['kid'];
      }
      if (!!decryptedObject['vnr']) {
        params.versicherungsnummer = decryptedObject['vnr'];
      }
    } else {
      if (!!shellParams['produktId']) {
        params.produktId = shellParams['produktId'];
      }
      if (!!shellParams['kollektivId']) {
        params.kollektivId = shellParams['kollektivId'];
      }
      if (!!shellParams['versicherungsnummer']) {
        params.versicherungsnummer = Number(shellParams['versicherungsnummer']);
      }
    }

    if (!!shellParams['antragsgenerationDatum']) {
      params.antragsgenerationDatum = shellParams['antragsgenerationDatum'];
    }
    if (!!this.schwebelfdnr) {
      params.schwebeLfdNR = this.schwebelfdnr;
    }

    const urlParams: AntragsannahmeUrlParams = new AntragsannahmeUrlParams();
    urlParams.produktId = this.produktId;
    urlParams.uiVorgangId = this.uiVorgangId;
    urlParams.antragsgenerationDatum = this.antragsgenerationDatum;
    if (!!this.versicherungsnummer) {
      const vnr = Number(this.versicherungsnummer);
      if (!!vnr) {
        urlParams.versicherungsnummer = vnr;
      }
    }
    urlParams.kollektivId = this.kollektivId;
    urlParams.schwebeLfdNR = this.schwebelfdnr;

    this._eventService.urlParams$.next(urlParams);


    if (this._uiConfigService.settings?.environment.name !== 'PRODUKTION' && (this._settings.app_root_url === '' || this._settings.app_root_url === window.location.origin + '/')) {
      const urlSearchParams = new URL(location.href).searchParams;
      let produktIdFromParams = urlSearchParams.get('produktId');
      const vorgangIdFromParams = urlSearchParams.get('vorgangId');
      let kollektivId = urlSearchParams.get('kollektivId');
      let vnrFromParams = Number(urlSearchParams.get('versicherungsnummer'));
      if (!!refInUrl) {
        const decryptedObject = JSON.parse(this._encryptionService.decrypt(refInUrl));
        if (!!decryptedObject['pid']) {
          produktIdFromParams = decryptedObject['pid'];
        }
        if (!!decryptedObject['kid']) {
          kollektivId = decryptedObject['kid'];
        }
        if (!!decryptedObject['vnr']) {
          vnrFromParams = Number(decryptedObject['vnr']);
        }
      }
      if (produktIdFromParams !== null) {
        this._shellConfigService.shellParameter.produktId = produktIdFromParams;
      }
      if (vorgangIdFromParams !== null) {
        this._shellConfigService.shellParameter.uiVorgangId = vorgangIdFromParams;
      }
      this._eventService.urlParams$.next({
        produktId: !!produktIdFromParams ? produktIdFromParams : this._shellConfigService.getParameter().produktId,
        uiVorgangId: !!vorgangIdFromParams ? vorgangIdFromParams : this._shellConfigService.getParameter().uiVorgangId,
        smsDoi: urlSearchParams.get('smsDoi') === 'true',
        emailDoi: urlSearchParams.get('emailDoi') === 'true',
        bonitaet: urlSearchParams.get('bonitaet') === 'true',
        compliance: urlSearchParams.get('compliance') === 'true',
        antragsgenerationDatum: !!shellParams['antragsgenerationDatum'] ? shellParams['antragsgenerationDatum'] : urlSearchParams.get('antragsgenerationDatum'),
        processId: urlSearchParams.get('processId'),
        versicherungsnummer: vnrFromParams,
        kollektivId: !!kollektivId ? kollektivId : null,
        schwebeLfdNR: !!this.schwebelfdnr ? this.schwebelfdnr : null
      } as AntragsannahmeUrlParams);
    }


  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

}
